import React, {useMemo} from "react";
import styled from "@emotion/styled";
import Highcharts, {Options} from "highcharts";
import mapModule from "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";

if (typeof Highcharts === "object") {
    mapModule(Highcharts);
}

interface IChart {
    height: string | number;
    width?: string | number;
    options: Options;
    loader?: React.ReactNode;
    type?: "mapChart" | "chart";
}

export const Chart = (props: IChart) => {
    const {height, loader, options = {}, width, type = "chart"} = props;

    const chartOptions: Options = useMemo(() => ({chart: {height}, credits: {enabled: false}, ...options}), [options]);

    if (loader) {
        return <div style={{height}}>{loader}</div>;
    }

    return (
        <ChartContainer height={height} width={width}>
            <HighchartsReact constructorType={type} highcharts={Highcharts} options={chartOptions} />
        </ChartContainer>
    );
};

interface IChartContainer {
    height?: string | number;
    width?: string | number;
}

const ChartContainer = styled.div<IChartContainer>`
    position: relative;
    height: ${(props) => props.height ?? "100%"};
    width: ${(props) => props.width ?? "100%"};
`;
import React, {useMemo} from "react";
import styled from "@emotion/styled";
import Highcharts, {Options} from "highcharts";
import mapModule from "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";

if (typeof Highcharts === "object") {
    mapModule(Highcharts);
}

interface IChart {
    height: string | number;
    width?: string | number;
    options: Options;
    loader?: React.ReactNode;
    type?: "mapChart" | "chart";
}

export const Chart = (props: IChart) => {
    const {height, loader, options = {}, width, type = "chart"} = props;

    const chartOptions: Options = useMemo(() => ({chart: {height}, credits: {enabled: false}, ...options}), [options]);

    if (loader) {
        return <div style={{height}}>{loader}</div>;
    }

    return (
        <ChartContainer height={height} width={width}>
            <HighchartsReact constructorType={type} highcharts={Highcharts} options={chartOptions} />
        </ChartContainer>
    );
};

interface IChartContainer {
    height?: string | number;
    width?: string | number;
}

const ChartContainer = styled.div<IChartContainer>`
    position: relative;
    height: ${(props) => props.height ?? "100%"};
    width: ${(props) => props.width ?? "100%"};
`;
